module.exports = __webpack_public_path__ + "img/comp-26.36230f44.png";